module.exports = "files/enemies.png";